

@if ((uploaded | async) == true) {
  <div class="mod_formfileupload">
    <div class="upload-row">
      <input type="file"
        id="uploaded_{{key}}"
        name="filesu"
        [readonly]="true"
        [disabled]="true"
        accept="{{accept}}"
        class="file is_valid"
        />
      <label for="uploaded_{{key}}">
        <span class="input_label" [title]="filename" (click)="download()">{{filename}}</span>
        <span class="mod_button" (click)="delete()">
          <span class="label">Durchsuchen</span>
        </span>
      </label>
      @if (validateSignature) {
        <app-signature-validation-icon
          [validation]="signatureValidation"
          [loading]="uploadingSignature"></app-signature-validation-icon>
      }
    </div>
    <p class="desc">Maximale Dateigrösse beträgt 1 GByte</p>
  </div>
} @else {
  <div class="mod_formfileupload" [ngClass]="{'error' : hasError()}">
    <div class="upload-row">
      <input type="file" id="upload_{{key}}"
        (change)="upload($event)"
        [readOnly]="readonly"
        [attr.disabled]="readonly ? '' : null"
        [attr.formControl]="control"
        name="files"
        accept="{{accept}}"
        class="file">
      <label for="upload_{{key}}">
        <span class="mod_button">
          <span class="label">Datei wählen</span>
        </span>
      </label>
      @if (validateSignature) {
        <app-signature-validation-icon
          [validation]="signatureValidation"
          [loading]="uploadingSignature"></app-signature-validation-icon>
      }
    </div>
    <p class="desc">{{label}} @if (isRequired) {
      <span>*</span>
    }</p>
    @if (null !== control && undefined !== submitted) {
      <br>
      }
      @if (null !== control && undefined !== submitted) {
        <app-input-error [submitted]="submitted" [control]="control"></app-input-error>
      }
    </div>
  }
